import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/header";

import { API, getCountries } from "../../services/api";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import AuthContext from "../../components/shared/AuthContext";

import { date_formats } from "../../services/data";

import moment from "moment";

import Swal from "sweetalert2";
import GoBack from "../../components/goBack";
import OrgContext from "../../organisation/OrgContext";
import { useNavigate } from "react-router-dom";
import useAuthHelper from "../../helpers/AuthHelper";
import {toast, ToastContainer} from "react-toastify";

function OrganisationProfile(props) {
  const { onlyAdmins } = useAuthHelper();

  const [t, i18n] = useTranslation();

  const { maxOrgs } = useContext(AuthContext);
  const { organisation, changeOrg } = useContext(OrgContext);

  const navigate = useNavigate();

  moment.locale(i18n.language);

  const [countries, setCountries] = useState([]);
  const [activities, setActivities] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [orgActivity, setOrgActivity] = useState("");
  const [descriptionActivite, setDescriptionActivite] = useState("");

  const [numberOfOrganisations,setNumberOfOrganisations] = useState(0);
  useEffect(() => {
    onlyAdmins();
    const fetchCountries = () => {
      getCountries()
        .then((data) => setCountries(data))
        .catch((err) => console.error(err));
    };

    const fetchActivities = async () => {
      const response = await jwtInterceoptor.get("/data/activities");

      if (response.status === 200) {
        setActivities(response.data.data);
      }
    };

    const fetchCurrencies = async () => {
      const response = await jwtInterceoptor.get("/data/currencies");

      if (response.status === 200) {
        setCurrencies(response.data.data);
      }
    };


    const fetchOrganisations = async () => {
      const response = await jwtInterceoptor.get("/data/organisations");

      if(response.status === 200){
        setNumberOfOrganisations(response.data.data.length);
      }
    };

    fetchOrganisations();
    fetchCountries();
    fetchActivities();
    fetchCurrencies();
  }, []);

  const LogoFile = useRef();
  const SignatureFile = useRef();
  const org_name = useRef("");
  const org_activity = useRef("");
  const org_address = useRef("");
  const org_addr_line1 = useRef("");
  const org_addr_line2 = useRef("");
  const org_ville = useRef("");
  const org_state = useRef("");
  const org_zip_code = useRef("");
  const org_tel = useRef("");
  const org_fax = useRef("");
  const org_web_site = useRef("");
  const org_email = useRef("");
  const org_currency = useRef("");
  const ice = useRef("");
  const idf = useRef("");
  const rc = useRef("");
  const documentFooter = useRef("");
  const capital = useRef("");

  const [previewLogo, setPreviewLogo] = useState(null);
  const [sectionDisplayForMorocco, setSectionDisplayForMorocco] =
    useState("none");
  const [sectionDisplay, setSectionDisplay] = useState("none");

  const [previewSignature, setPreviewSignature] = useState(null);

  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeLogo = (event) => {
    if (event.target?.files[0]) {
      setPreviewLogo(event.target.files[0]);
    }
  };

  const onChangeSignature = (event) => {
    if (event.target?.files[0]) {
      setPreviewSignature(event.target.files[0]);
    }
  };

  const checkPack = (event) => {
    console.log("maxOrgs:", maxOrgs);
    console.log("numberOfOrganisations:", numberOfOrganisations);
    if (numberOfOrganisations >= maxOrgs){
      toast.warning(
          t("Vous avez atteint la limite de création de nouvelles organisations. Pour demander une modification de votre forfait, veuillez contacter le service commercial à l'adresse suivante : commerciale@elmanager.ma."),
          {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
      );
    }
    else{
      submit(event);
    }
  }

  const submit = async (event) => {
    event.preventDefault();

    setIsSubmit(true);
    if (
      org_name.current.value.trim().length > 0 &&
      org_activity.current.value.trim().length > 0 &&
      org_address.current.value.trim().length > 0 &&
      org_addr_line1.current.value.trim().length > 0 &&
      org_ville.current.value.trim().length > 0 &&
      org_state.current.value.trim().length > 0 &&
      org_zip_code.current.value.trim().length > 0 &&
      org_tel.current.value.trim().length > 0 &&
      org_currency.current.value.trim().length > 0 &&
      previewLogo &&
      (org_address.current.value === "144"
        ? ice.current.value.trim().length > 0
        : documentFooter.current.value.trim().length > 0)
    ) {
      try {
        let formData = new FormData();

        formData.append("logo", previewLogo);
        formData.append("signature", previewSignature);
        formData.append("name", org_name.current.value);
        formData.append("activity_id", org_activity.current.value);
        formData.append("country_id", org_address.current.value);
        formData.append("currency_id", org_currency.current.value); 
        formData.append("address_line1", org_addr_line1.current.value);
        formData.append("address_line2", org_addr_line2.current.value);
        formData.append("state", org_state.current.value);
        formData.append("city", org_ville.current.value);
        formData.append("zip_code", org_zip_code.current.value);
        formData.append("phone", org_tel.current.value);
        formData.append(
          "web_site",
          org_web_site.current.value ? org_web_site.current.value : ""
        );
        formData.append(
          "fax",
          org_fax.current.value ? org_fax.current.value : ""
        );
        formData.append("ice", ice.current.value);
        formData.append("if", idf.current.value);
        formData.append("rc", rc.current.value);
        formData.append("documentFooter", documentFooter.current.value);
        formData.append("email", org_email.current.value);
        formData.append("capital", capital.current.value);
        if(orgActivity==33){
            formData.append("autre",descriptionActivite);
        }

        const response = await jwtInterceoptor.post(
          "/data/organisations",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status == 200) {
          if (response.data.status == true) {
            if (response.data.organisation) {
              const org = response.data.organisation;
              if (!localStorage.getItem("orgs")) {
                changeOrg(org);
              }
            }

            Swal.fire({
              icon: "success",
              text: t(response.data.message),
            });

            navigate("/organisations/list");
            window.location.reload();
            return;
          } else {
            if (response.data?.data) {
              let messageError = "<ul>";
              let keysErrors = Object.keys(response.data?.data);
              keysErrors?.map((key) => {
                messageError += `<li>${t(key)}: `;
                messageError += t(response.data?.data[key][0]);
                messageError += "</li>";
              });
              messageError += "</ul>";
              Swal.fire({
                icon: "warning",
                title: "",
                html: messageError,
              });
            } else {
              Swal.fire({
                icon: "warning",
                title: "",
                text: t("Something went wrong!, try again"),
              });
            }
            setIsSubmit(false);
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "",
            text: t("Something went wrong!, try again"),
          });
          setIsSubmit(false);
        }
      } catch (error) {
        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
        setIsSubmit(false);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "",
        text: t("Fill all fields"),
      });
      setIsSubmit(false);
    }
  };

  return (
    <>
      <ToastContainer/>

      {organisation ? <GoBack route="/organisations/list" /> : null}

      {organisation == null ? (
        <div className="row">
          <div className="col-xl-4 col-sm-12"></div>
          <div className="col-xl-4 col-sm-12">
            <div className="card border p-0 pb-3">
              <div className="card-header border-0 pt-3">
                <div className="card-options">
                  <a
                    href="javascript:void(0)"
                    className="card-options-remove"
                    data-bs-toggle="card-remove"
                  >
                    <i className="fe fe-x"></i>
                  </a>
                </div>
              </div>
              <div className="card-body text-center">
                <span className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="60"
                    width="60"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#fad383"
                      d="M15.728,22H8.272a1.00014,1.00014,0,0,1-.707-.293l-5.272-5.272A1.00014,1.00014,0,0,1,2,15.728V8.272a1.00014,1.00014,0,0,1,.293-.707l5.272-5.272A1.00014,1.00014,0,0,1,8.272,2H15.728a1.00014,1.00014,0,0,1,.707.293l5.272,5.272A1.00014,1.00014,0,0,1,22,8.272V15.728a1.00014,1.00014,0,0,1-.293.707l-5.272,5.272A1.00014,1.00014,0,0,1,15.728,22Z"
                    ></path>
                    <circle cx="12" cy="16" r="1" fill="#f7b731"></circle>
                    <path
                      fill="#f7b731"
                      d="M12,13a1,1,0,0,1-1-1V8a1,1,0,0,1,2,0v4A1,1,0,0,1,12,13Z"
                    ></path>
                  </svg>
                </span>
                <h4 className="h4 mb-0 mt-3">{t("Alerte")}</h4>
                <p className="card-text">
                  {t(
                    "Est nécessaire d'ajouter une organisation pour continuer à utiliser votre application"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-sm-12"></div>
        </div>
      ) : null}

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">{t("Profil de l'organisation")}</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Votre logo")} (
                  <span className="text-red">{t("Taille")} Max 1 Mo</span>){" "}
                  <span className="text-red">*</span>
                </label>
                <div className="dropify-wrapper" style={{ height: 100.6 }}>
                  <div className="dropify-message">
                    <span className="file-icon">
                      {" "}
                      <p>{t("alert_drop")}</p>
                    </span>
                    <p className="dropify-error">
                      Ooops, something wrong appended.
                    </p>
                  </div>
                  <div className="dropify-loader"></div>
                  <div className="dropify-errors-container">
                    <ul></ul>
                  </div>
                  <input
                    type="file"
                    ref={LogoFile}
                    className="dropify"
                    onChange={onChangeLogo}
                    data-height="180"
                  />
                  <button type="button" className="dropify-clear">
                    Remove
                  </button>
                  <div className="dropify-preview">
                    <span className="dropify-render"></span>
                    <div className="dropify-infos">
                      <div className="dropify-infos-inner">
                        <p className="dropify-filename">
                          <span className="dropify-filename-inner"></span>
                        </p>
                        <p className="dropify-infos-message">
                          Drag and drop or click to replace
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {previewLogo ? (
                <div>
                  <img src={URL.createObjectURL(previewLogo)} width={200} />
                </div>
              ) : null}
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Signature")} (
                  <span className="text-red">{t("Taille")} Max 1 Mo</span>)
                </label>
                <div className="dropify-wrapper" style={{ height: 100.6 }}>
                  <div className="dropify-message">
                    <span className="file-icon">
                      {" "}
                      <p>{t("alert_drop")}</p>
                    </span>
                    <p className="dropify-error">
                      Ooops, something wrong appended.
                    </p>
                  </div>
                  <div className="dropify-loader"></div>
                  <div className="dropify-errors-container">
                    <ul></ul>
                  </div>
                  <input
                    type="file"
                    className="dropify"
                    onChange={onChangeSignature}
                    data-height="180"
                  />
                  <button type="button" className="dropify-clear">
                    Remove
                  </button>
                  <div className="dropify-preview">
                    <span className="dropify-render"></span>
                    <div className="dropify-infos">
                      <div className="dropify-infos-inner">
                        <p className="dropify-filename">
                          <span className="dropify-filename-inner"></span>
                        </p>
                        <p className="dropify-infos-message">
                          Drag and drop or click to replace
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {previewSignature ? (
                <div>
                  <img
                    src={URL.createObjectURL(previewSignature)}
                    width={200}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Nom de l'organisation")}{" "}
                  <span className="text-red">*</span>
                </label>
                <input
                  type="text"
                  ref={org_name}
                  className="form-control"
                  placeholder={t("Nom de l'organisation")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Activité")} <span className="text-red">*</span>
                </label>

                <select
                  ref={org_activity}
                  value={orgActivity}
                  onChange={(e) => {
                    setOrgActivity(e.target.value);
                  }}
                  className="form-control form-select"
                  placeholder={t("Activité")}
                >
                  <option></option>
                  {activities.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.name}
                    </option>
                  ))}
                </select>

                {orgActivity == 33 && (
                  <>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label
                          htmlFor="descriptioActivite"
                          className="form-label"
                        >
                          Votre Activité
                        </label>{" "}   
                        <input
                          type="text"
                          name="deAc"
                          id="descriptioActivite"
                          className="form-control"
                          value={descriptionActivite}
                          onChange={(e) => {
                            setDescriptionActivite(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Adresse de l'entreprise")}{" "}
                  <span className="text-red">*</span>
                </label>

                <select
                  onChange={(e) => {
                    if (e.target.value === "144") {
                      setSectionDisplayForMorocco("block");
                      setSectionDisplay("none");
                    } else {
                      setSectionDisplay("block");
                      setSectionDisplayForMorocco("none");
                    }
                  }}
                  ref={org_address}
                  className="form-control form-select"
                  placeholder={t("Adresse de l'entreprise")}
                >
                  <option></option>
                  {countries.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nicename}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="row" style={{ display: sectionDisplayForMorocco }}>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("L'identifiant Commun de l'Entreprise")}*
                </label>
                <input ref={ice} type="text" className="form-control" />
              </div>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("L'identifiant Fiscal")}{" "}
                </label>
                <input ref={idf} type="text" className="form-control" />
              </div>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("L'immatriculation au Registre du Commerce")}{" "}
                </label>
                <input ref={rc} type="text" className="form-control" />
              </div>
            </div>
          </div>

          <div className="row" style={{ display: sectionDisplay }}>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">{t("L'bas de la page")}*</label>
                <textarea
                  ref={documentFooter}
                  className="form-control"
                ></textarea>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-label">
                  {t("Adresse de la société")}{" "}
                  <span className="text-red">*</span>
                </label>
                <input
                  ref={org_addr_line1}
                  type="text"
                  className="form-control"
                  placeholder={t("Rue 1")}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <input
                  ref={org_addr_line2}
                  type="text"
                  className="form-control"
                  placeholder={t("Rue 2")}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">
                  {t("Ville")} <span className="text-red">*</span>
                </label>
                <input
                  ref={org_ville}
                  type="text"
                  className="form-control"
                  placeholder={t("Ville")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">
                  {t("État/Province")} <span className="text-red">*</span>
                </label>
                <input
                  ref={org_state}
                  type="text"
                  className="form-control"
                  placeholder={t("État/Province")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">
                  {t("Code postal")} <span className="text-red">*</span>
                </label>
                <input
                  ref={org_zip_code}
                  type="text"
                  className="form-control"
                  placeholder={t("Code postal")}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">
                  {t("Téléphone")} <span className="text-red">*</span>
                </label>
                <input
                  ref={org_tel}
                  type="text"
                  className="form-control"
                  placeholder={t("Téléphone")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">{t("Fax")}</label>
                <input
                  ref={org_fax}
                  type="text"
                  className="form-control"
                  placeholder={t("Fax")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <label className="form-label">{t("Site Internet")}</label>
                <input
                  ref={org_web_site}
                  type="text"
                  className="form-control"
                  placeholder={t("Site Internet")}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">{t("Email")}</label>

                <input
                  ref={org_email}
                  type="email"
                  className="form-control"
                  placeholder={t("Email")}
                />
              </div>
            </div>
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">
                  {t("Devise de base")} <span className="text-red">*</span>
                </label>

                <select
                  ref={org_currency}
                  className="form-control form-select"
                  placeholder={t("Devise de base")}
                >
                  <option></option>
                  {currencies.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.code} - {c.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6">
              <div className="form-group">
                <label className="form-label">{t("Capital")}</label>
                <input
                  ref={capital}
                  type="number"
                  className="form-control"
                  placeholder={t("Capital")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <button
            disabled={isSubmit}
            type="button"
            onClick={checkPack}
            className="btn btn-primary"
          >
            {isSubmit ? t("Loading ...") : t("Enregistrer")}
          </button>
        </div>
      </div>
    </>
  );
}

export default OrganisationProfile;
